<template>
  <header :class="[`header`, visible ? `header--visible` : ``]">
    <h1 :style="logoStyles" class="logo" @click="toHome">Moda Operandi</h1>
  </header>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex'

import logoSVG from '@/assets/images/navigation-logo.svg'

export default {
  name: `ui-header`,

  // Components
  // Data
  data () {
    return {
      headerVisibleOn: [
        `detail`
      ],
      logoStyles: {
        backgroundImage: `url(${logoSVG})`
      }
    }
  },

  // Computed
  computed: {
    ...mapGetters(`header`, [`visible`])
  },

  // Methods
  methods: {
    ...mapActions(`header`, [`toggleHeader`]),

    toHome () {
      this.$router.push({ name: `home` })
    }
  }
  // Watchers

  // Lifecycles
  // Filters
}
</script>
